<template>
  <b-form-group :label="field.label" :label-for="`${field.key}Input`" :description="field.description">

    <b-form-checkbox v-model="useDefault">
      Use default value
    </b-form-checkbox>
    <b-form-checkbox v-model="isDisabled" :disabled="useDefault">
      Disable
    </b-form-checkbox>

    <b-form-input :id="`${field.key}Input`" type="number"
      :disabled="useDefault || isDisabled" :required="!useDefault && !isDisabled" v-model="contents"/>
  </b-form-group>
</template>

<script>
export default {
  props: {
    field: Object,
    value: Object,
  },
  data() {
    return {
      contents: null,
      useDefault: this.value ? this.value.default : true,
      isDisabled: this.value ? this.value.disabled : true,
    };
  },
  created() {
    this.contents = this.getContents();
  },
  methods: {
    emitInput() {
      if (this.useDefault) {
        this.$emit('input', Object.assign(this.value, { value: null, disabled: false }));
      } else if (this.isDisabled) {
        this.$emit('input', Object.assign(this.value, { value: null, disabled: true }));
      } else {
        this.$emit('input', Object.assign(this.value, { value: parseInt(this.contents, 10), disabled: false }));
      }
    },
    getContents() {
      return this.value.value || this.value.placeholder;
    },
    tokenVar(token) {
      return `{{${token}}}`;
    },
  },
  watch: {
    useDefault() {
      this.emitInput();
    },
    isDisabled() {
      this.emitInput();
    },
    contents() {
      this.emitInput();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/ScoreBlock.vue